import { APIConnector, Settings } from "../base";

const apiConnector = new APIConnector({ timeout: 1200000 });

export default class DeclaracionJuradaConfig {
	static get base() {
		return Settings.server + "/ddjj";
	}

	static get endpointGetDeclaracionJuradas() {
		return DeclaracionJuradaConfig.base;
	}

	static get endpointProcesarExcel() {
		return `${DeclaracionJuradaConfig.base}/procesar-excel`;
	}

	static get endpointCreateDJ() {
		return `${DeclaracionJuradaConfig.base}`;
	}

	static get endpointCheckPeriodo() {
		return `${DeclaracionJuradaConfig.base}/check-periodo`;
	}

	static get endpointCheckPeriodoFixedContribution() {
		return `${DeclaracionJuradaConfig.base}/check-periodo-fixed-contrib`;
	}

	static get endpointDJDetail() {
		return `${DeclaracionJuradaConfig.base}/dj-detail`;
	}

	static get endpointPrintDJ() {
		return `${DeclaracionJuradaConfig.base}/generate-report-dj`;
	}

	static get APIConnector() {
		return apiConnector;
	}
}



// WEBPACK FOOTER //
// ./src/provider/DeclaracionJurada/DeclaracionJuradaConfig.js